webpackJsonp([2778885190596],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = FormError;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isArray = __webpack_require__(25);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _messageBlock = __webpack_require__(65);
	
	var _messageBlock2 = _interopRequireDefault(_messageBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormError(_ref) {
	  var message = _ref.message;
	
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', position: 'top', size: 'm' },
	    _react2.default.createElement(
	      _messageBlock2.default,
	      { textAlign: 'left', type: 'error', fullWidth: true },
	      (0, _isArray2.default)(message) ? message.map(function (text) {
	        return _react2.default.createElement(
	          'div',
	          { key: text },
	          text
	        );
	      }) : message
	    )
	  );
	}
	
	FormError.propTypes = {
	  message: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FormErrorLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function FormErrorLink(_ref) {
	  var isExternal = _ref.isExternal,
	      url = _ref.url,
	      children = _ref.children,
	      otherProps = _objectWithoutProperties(_ref, ['isExternal', 'url', 'children']);
	
	  var props = _extends({
	    type: 'opaqueReversed',
	    hasUnderline: true
	  }, otherProps);
	  return isExternal ? _react2.default.createElement(
	    _link2.default,
	    _extends({ url: url, target: '_blank' }, props),
	    children
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: url },
	    _react2.default.createElement(
	      _link2.default,
	      props,
	      children
	    )
	  );
	}
	
	FormErrorLink.propTypes = {
	  isExternal: _propTypes2.default.bool,
	  url: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Maintenance;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _button = __webpack_require__(14);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _SmartLink = __webpack_require__(36);
	
	var _SmartLink2 = _interopRequireDefault(_SmartLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Maintenance() {
	  var twitterLink = 'https://twitter.com/marvelapp';
	  var contactLink = 'https://help.marvelapp.com/hc/en-us/requests/new';
	  return _react2.default.createElement(
	    _spacing2.default,
	    { type: 'padding', size: 'xl', position: 'topBottom' },
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 's', position: 'bottom' },
	      _react2.default.createElement(
	        _heading2.default,
	        { tag: 'h1', size: 'xxxl', weight: 'bold' },
	        'We\u2019ll be back soon!'
	      )
	    ),
	    _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: 'm', position: 'bottom' },
	      _react2.default.createElement(
	        _maxWidth2.default,
	        { value: 370 },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'l', color: 'slate' },
	          'Marvel is unavailable while we switch over to the new Marvel 3 but we\'ll be back up in a few hours. In the meantime, you can read more on the new features and improvements and stay up to date with downtime updates on',
	          ' ',
	          _react2.default.createElement(
	            _SmartLink2.default,
	            { type: 'blue', url: twitterLink },
	            'Twitter'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _SmartLink2.default,
	      { url: contactLink },
	      _react2.default.createElement(
	        _button2.default,
	        { shape: 'rounded' },
	        'Get in touch'
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hubspotFormSubmit = __webpack_require__(772);
	
	var _hubspotFormSubmit2 = _interopRequireDefault(_hubspotFormSubmit);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _without = __webpack_require__(299);
	
	var _without2 = _interopRequireDefault(_without);
	
	var _difference = __webpack_require__(291);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	var _FormError = __webpack_require__(200);
	
	var _FormError2 = _interopRequireDefault(_FormError);
	
	var _FormErrorLink = __webpack_require__(201);
	
	var _FormErrorLink2 = _interopRequireDefault(_FormErrorLink);
	
	var _FormWrap = __webpack_require__(202);
	
	var _FormWrap2 = _interopRequireDefault(_FormWrap);
	
	var _forms = __webpack_require__(49);
	
	var _fetch = __webpack_require__(63);
	
	var _api = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignupForm = function (_Component) {
	  _inherits(SignupForm, _Component);
	
	  function SignupForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SignupForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      backendErrorMsg: {},
	      company: '',
	      email: '',
	      invalidFields: [],
	      isPending: false,
	      name: '',
	      password: '',
	      validFields: []
	    }, _this.fields = [{
	      label: 'Full name',
	      name: 'name',
	      placeholder: "What's your full name?",
	      class: 'input'
	    }, {
	      errorMsg: 'Please enter a valid email address',
	      label: 'Email address',
	      name: 'email',
	      placeholder: 'you@example.com',
	      type: 'email',
	      class: 'input'
	    }, {
	      errorMsg: 'Must have at least 8 characters!',
	      label: 'Password',
	      name: 'password',
	      placeholder: 'Enter 8 characters or more',
	      type: 'password',
	      class: 'input'
	    }, {
	      errorMsg: 'Provided company name must be at least 2 characters!',
	      label: 'Company name (optional)',
	      name: 'company',
	      placeholder: 'Where do you work?',
	      class: 'input'
	    }], _this.inputFieldNames = _this.fields.map(function (field) {
	      return field.name;
	    }), _this.setFieldValue = function (e, fieldName) {
	      var value = e.target.value;
	      var validFields = [];
	
	      if (_this.state.validFields.indexOf(fieldName) !== -1) {
	        var _this$setState;
	
	        validFields = (0, _without2.default)(validFields, fieldName);
	        _this.setState((_this$setState = {}, _this$setState[fieldName] = value, _this$setState.validFields = validFields, _this$setState));
	      } else {
	        var _this$setState2;
	
	        _this.setState((_this$setState2 = {}, _this$setState2[fieldName] = value, _this$setState2));
	      }
	    }, _this.validateForm = function (e) {
	      e.preventDefault();
	      if (_this.isFormValid()) {
	        if (_this.props.showFullForm) {
	          _this.createAccount();
	        } else {
	          _this.updateUserDetails();
	        }
	      }
	    }, _this.isFormValid = function () {
	      var _this$state = _this.state,
	          email = _this$state.email,
	          password = _this$state.password,
	          company = _this$state.company;
	
	      var invalidFields = [];
	
	      if (_this.props.showFullForm) {
	        (0, _forms.validateEmailAndPassword)(email, password, invalidFields);
	      }
	      if (!(0, _forms.isCompanyNameValid)(company)) {
	        invalidFields.push('company');
	      }
	
	      var validFields = (0, _difference2.default)(_this.inputFieldNames, invalidFields);
	
	      _this.setState({
	        invalidFields: invalidFields,
	        backendErrorMsg: {},
	        validFields: validFields
	      });
	      return !invalidFields.length;
	    }, _this.createAccount = function () {
	      var _this$state2 = _this.state,
	          email = _this$state2.email,
	          password = _this$state2.password,
	          name = _this$state2.name,
	          company = _this$state2.company;
	
	      _this.setState({ isPending: true });
	      (0, _forms.makeCreateAccountRequest)({
	        email: email,
	        password: password,
	        name: name || (0, _forms.getUsernameFromEmail)(email),
	        success: function success() {
	          return _this.initialRequestSuccess(company);
	        },
	        failure: _this.displayServerError
	      });
	    }, _this.updateUserDetails = function () {
	      var _this$state3 = _this.state,
	          name = _this$state3.name,
	          company = _this$state3.company;
	
	      _this.setState({ isPending: true });
	      var userEmail = _this.props.userEmail;
	
	      if (name && userEmail) {
	        (0, _fetch.fetchApi)('PUT', _api.API_USER, {
	          username: name,
	          email: userEmail
	        }).then(function () {
	          return _this.initialRequestSuccess(company);
	        }).catch(_this.displayServerError);
	      } else if (company) {
	        _this.updateCompany();
	      } else {
	        _this.redirectTo();
	      }
	    }, _this.updateCompany = function () {
	      (0, _fetch.fetchApi)('PUT', _api.API_COMPANY, {
	        name: _this.state.company,
	        phone_number: ''
	      }).then(_this.redirectTo).catch(_this.displayServerError);
	    }, _this.initialRequestSuccess = function (company) {
	      var names = (0, _forms.splitNames)(_this.state.name);
	      var ignoreMarketing = (0, _forms.getIgnoreMarketingParam)();
	      var isCommenter = (0, _forms.getCommenterParam)();
	      _this.secondaryRequestSuccess(company);
	
	      (0, _hubspotFormSubmit2.default)(_api.HUBSPOT_ID, _this.props.hubspotId, {
	        company: company,
	        email: _this.state.email,
	        firstname: names.firstName,
	        lastname: names.lastName,
	        unsubscribed_from_emails: ignoreMarketing,
	        commenter: isCommenter
	      });
	    }, _this.secondaryRequestSuccess = function (company) {
	      if (company) {
	        _this.updateCompany();
	      } else {
	        _this.redirectTo();
	      }
	    }, _this.redirectTo = function () {
	      window.location.href = _this.props.redirectTo;
	    }, _this.displayServerError = function (error) {
	      var backendErrorMsg = getErrorMessage(error);
	
	      _this.setState({
	        isPending: false,
	        backendErrorMsg: backendErrorMsg
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  SignupForm.prototype.render = function render() {
	    var _state = this.state,
	        backendErrorMsg = _state.backendErrorMsg,
	        invalidFields = _state.invalidFields,
	        isPending = _state.isPending,
	        validFields = _state.validFields;
	    var _props = this.props,
	        showFullForm = _props.showFullForm,
	        messaging = _props.messaging,
	        buttonTxt = _props.buttonTxt,
	        buttonColor = _props.buttonColor,
	        headerAlign = _props.headerAlign,
	        isCommenter = _props.isCommenter;
	
	
	    var inputsArray = showFullForm ? this.fields : this.fields.slice(0, 2);
	
	    if (isCommenter) {
	      inputsArray = this.fields.slice(0, 3);
	    }
	
	    var buttonProps = {
	      text: buttonTxt,
	      minWidth: 220,
	      color: buttonColor,
	      tabIndex: 9
	    };
	
	    return _react2.default.createElement(
	      _FormWrap2.default,
	      {
	        action: _api.API_CREATE_ACCOUNT,
	        autocomplete: 'off',
	        backendErrorMsg: backendErrorMsg,
	        buttonProps: buttonProps,
	        fields: inputsArray,
	        invalidFields: invalidFields,
	        isPending: isPending,
	        messaging: messaging,
	        setFieldValue: this.setFieldValue,
	        validateForm: this.validateForm,
	        validFields: validFields,
	        headerAlign: headerAlign,
	        redirectTo: this.props.redirectTo
	      },
	      _react2.default.createElement(_FormError2.default, backendErrorMsg)
	    );
	  };
	
	  return SignupForm;
	}(_react.Component);
	
	exports.default = SignupForm;
	
	
	SignupForm.propTypes = {
	  buttonTxt: _propTypes2.default.string.isRequired,
	  redirectTo: _propTypes2.default.string,
	  messaging: _propTypes2.default.object.isRequired,
	  setShowFullForm: _propTypes2.default.func,
	  showFullForm: _propTypes2.default.bool,
	  userEmail: _propTypes2.default.string,
	  headerAlign: _propTypes2.default.string,
	  buttonColor: _propTypes2.default.string,
	  hubspotId: _propTypes2.default.string,
	  isCommenter: _propTypes2.default.bool
	};
	
	SignupForm.defaultProps = {
	  showFullForm: true
	};
	
	function getErrorMessage(error) {
	  var data = error && error.data || {};
	
	  if (data.email) {
	    return {
	      message: _react2.default.createElement(
	        'span',
	        null,
	        'Email already exists.',
	        ' ',
	        _react2.default.createElement(
	          _FormErrorLink2.default,
	          { url: '/signin/reset-password' },
	          'Forgot password?'
	        )
	      ),
	      fields: ['email']
	    };
	  }
	
	  if (data.invite_token) {
	    return {
	      message: _react2.default.createElement(
	        'span',
	        null,
	        'This email is already associated to an account. Please accept the link in the email invite or',
	        ' ',
	        _react2.default.createElement(
	          _FormErrorLink2.default,
	          { url: 'https://help.marvelapp.com/', isExternal: true },
	          'contact support'
	        ),
	        '.'
	      )
	    };
	  }
	
	  if (data.password) {
	    return {
	      message: data.password,
	      fields: ['password']
	    };
	  }
	
	  return {
	    message: _react2.default.createElement(
	      'span',
	      null,
	      'There was an error signing up. Please try again or',
	      ' ',
	      _react2.default.createElement(
	        _FormErrorLink2.default,
	        { url: 'https://help.marvelapp.com/', isExternal: true },
	        'contact support'
	      ),
	      '.'
	    )
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(38);
	
	var _selectors = __webpack_require__(69);
	
	var _actionCreators = __webpack_require__(522);
	
	var _SignupForm = __webpack_require__(1213);
	
	var _SignupForm2 = _interopRequireDefault(_SignupForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapStateToProps(state) {
	  return {
	    // hardcode this to true so we're able to deploy a csrf fix,
	    // until we're able to confirm that the short form is no longer used
	    // https://github.com/marvelapp/marvelapp_pie/pull/5013
	    showFullForm: true,
	    userEmail: (0, _selectors.getUserEmail)(state)
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setShowFullForm: function setShowFullForm() {
	      return dispatch((0, _actionCreators.showFullForm)());
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SignupForm2.default);
	module.exports = exports['default'];

/***/ }),

/***/ 1301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SIGNUP_PAGE_QUERY = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(38);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _link = __webpack_require__(15);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _SignupForm = __webpack_require__(1214);
	
	var _SignupForm2 = _interopRequireDefault(_SignupForm);
	
	var _AccountPagesWrap = __webpack_require__(146);
	
	var _AccountPagesWrap2 = _interopRequireDefault(_AccountPagesWrap);
	
	var _Maintenance = __webpack_require__(593);
	
	var _Maintenance2 = _interopRequireDefault(_Maintenance);
	
	var _hubspot = __webpack_require__(46);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _selectors = __webpack_require__(69);
	
	var _forms = __webpack_require__(49);
	
	var _urls = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SignUp(_ref) {
	  var showFullForm = _ref.showFullForm,
	      history = _ref.history,
	      data = _ref.data;
	
	  var isCommenter = (0, _forms.getCommenterParam)();
	
	  var meta = {
	    title: _metadata2.default.signup.title,
	    meta: [{
	      name: 'description',
	      content: _metadata2.default.signup.description
	    }, { name: 'keywords', content: _metadata2.default.signup.keywords }],
	    header: false
	  };
	
	  if (data.site.siteMetadata.siteMaintenance) {
	    return _react2.default.createElement(
	      _Page2.default,
	      meta,
	      _react2.default.createElement(
	        _AccountPagesWrap2.default,
	        { history: history, isSignUpPage: true },
	        _react2.default.createElement(_Maintenance2.default, null),
	        _react2.default.createElement('div', null)
	      )
	    );
	  }
	
	  var heading = isCommenter ? 'Sign up to leave a comment' : 'Create your free account';
	  var copy = isCommenter ? _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'l', position: 'bottom' },
	    _react2.default.createElement(
	      _paragraph2.default,
	      { size: 'm', color: 'slate' },
	      'This is so we can send you comment notifications and updates for the projects you comment on.'
	    )
	  ) : null;
	
	  var messaging = {
	    header: _react2.default.createElement(
	      _spacing2.default,
	      { type: 'margin', size: isCommenter ? 'm' : 'l', position: 'bottom' },
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', size: 'xl', sizeM: '0', position: 'right' },
	        _react2.default.createElement(
	          _maxWidth2.default,
	          { value: 280 },
	          _react2.default.createElement(
	            _heading2.default,
	            { tag: 'h1', size: 'xxxl', weight: 'bold' },
	            heading
	          )
	        )
	      )
	    ),
	    copy: copy
	  };
	
	  var buttonTxt = 'Create your free account';
	
	  if (!showFullForm) {
	    messaging = {
	      header: _react2.default.createElement(
	        _heading2.default,
	        { tag: 'h1', size: 'xl', weight: 'semibold' },
	        'Finish your sign up'
	      ),
	      copy: _react2.default.createElement(
	        _paragraph2.default,
	        { size: 'm', color: 'slate' },
	        'Enter the details below to set up your account.'
	      )
	    };
	
	    buttonTxt = 'Finish';
	  }
	
	  var redirectTo = (0, _forms.getNextSignupRedirect)();
	  var signinLinkWithRedirect = (0, _forms.getUrlWithRedirect)(_urls.SIGNIN);
	
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(
	      _AccountPagesWrap2.default,
	      { history: history, isSignUpPage: true },
	      _react2.default.createElement(_SignupForm2.default, {
	        messaging: messaging,
	        redirectTo: redirectTo,
	        buttonTxt: buttonTxt,
	        hubspotId: _hubspot.formSignupRegistrationPageId,
	        isCommenter: isCommenter
	      }),
	      _react2.default.createElement(
	        _spacing2.default,
	        { type: 'margin', position: 'topBottom', size: 'm' },
	        _react2.default.createElement(
	          _paragraph2.default,
	          { size: 'm', color: 'slate' },
	          'By signing up, you agree to our',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/terms' },
	            _react2.default.createElement(
	              _link2.default,
	              { type: 'blue' },
	              'communications and usage terms'
	            )
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'breakPointM-display-block' },
	            'Already have an account?',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: signinLinkWithRedirect, type: 'blue' },
	              _react2.default.createElement(
	                _link2.default,
	                { type: 'blue' },
	                'Sign in'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	var SIGNUP_PAGE_QUERY = exports.SIGNUP_PAGE_QUERY = '** extracted graphql fragment **';
	
	SignUp.propTypes = {
	  showFullForm: _propTypes2.default.bool,
	  history: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.shape({
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        siteMaintenance: _propTypes2.default.bool.isRequired
	      }).isRequired
	    }).isRequired
	  }).isRequired
	};
	
	SignUp.defaultProps = {
	  showFullForm: true
	};
	
	function mapStateToProps(state) {
	  return {
	    showFullForm: (0, _selectors.shouldShowFullForm)(state)
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(SignUp);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signup-index-js-40d70d965f56b2fb4157.js